// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2V92C","alert":"SettungsInbox_alert__1-j5_"};